import { useEffect, useRef, useState } from "react";
import {
  mostraAlertaError,
  mostraAlertaOk,
} from "../../componentes/alerts/sweetAlert";
import { AxiosImagen, AxiosPrivado } from "../../componentes/axios/Axios";
import Card from "../../componentes/contenedores/Card";
import GestionUbicacion from "../../componentes/googlemap/GestionUbicacion";
import VerUbicacion from "../../componentes/googlemap/VerUbicacion";
import Page from "../../componentes/plantilla/Page";
import {
  EmpleadoImagenEditar,
  EmpleadosGuardar,
  EmpleadosListar,
  ImagenEmpleado,
  CargosListar,
} from "../../configuracion/apiUrls";
import { DireccionConfig, permisosPorRuta } from "../../configuracion/Empresa";
import { regexContrasena, regexEmail, regexIdentidad, regexNombre, regexNombreOpcionalValido, regexRTN, regexTelefono } from "../../configuracion/validaciones";
import { useContextEmpleado } from "../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";
import { ErroresPeticion } from "../../componentes/axios/ErroresPeticion";

const getPermisosString = (permisos) => {
  if (Array.isArray(permisos)) {
    return permisos.slice().sort().join(",");
  } else if (typeof permisos === "string") {
    return permisos.split(",").map(p => p.trim()).sort().join(",");
  } else {
    return "";
  }
};

const NuevoEmpleado = () => {
  const { token } = useContextUsuario();
  const { listaCargos, setListaEmpleados, ActualizarLista, setListaCargos } =
    useContextEmpleado();
  const [nuevaDireccion, setNuevaDireccion] = useState({
    direccion: DireccionConfig.direccion,
    longitud: DireccionConfig.longitud,
    latitud: DireccionConfig.latitud,
  });
  const [seleccionarDireccion, setSeleccionarDireccion] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [imagen, setImagen] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [formularioEmpleados, setFormularioEmpleados] = useState({
    id: null,
    correo: "",
    identidad: "",
    rtn: "",
    primerNombre: "",
    segundoNombre: "",
    primerApellido: "",
    segundoApellido: "",
    cargoId: null,
    telefonos: [{ telefono: "" }],
    direcciones: [{ direccion: "", longitud: null, latitud: null }],
    genero: "Masculino",
    activo: true,
    imagen: "empleados.jpeg",
    contrasena: "",
    nombre: "",
    tipoUsuario: "Empleado",
  });
  const generos = [
    {
      value: 1,
      label: "Masculino",
      otro: "M",
    },
    {
      value: 2,
      label: "Femenino",
      otro: "F",
    },
  ];
  const cargos = listaCargos.map((f) => ({
    value: f.id,
    label: f.nombre_cargo,
  }));
  const datos = {
    titulo: {
      titulo: "Nuevo empleado",
      url: "/app/empleados",
      tituloUrl: "empleados",
      nombreUrl: "nuevo",
    },
  };
  const [generoId, setGeneroId] = useState(null);
  const [errorIdentidad, setErrorIdentidad] = useState(false);
  const [errorRtn, setErrorRtn] = useState(false);
  const [errorPrimerNombre, setErrorPrimerNombre] = useState(false);
  const [errorSegundoNombre, setErrorSegundoNombre] = useState(false);
  const [errorPrimerApellido, setErrorPrimerApellido] = useState(false);
  const [errorSegundoApellido, setErrorSegundoApellido] = useState(false);
  const [errorCorreo, setErrorCorreo] = useState(false);
  const [errorUsuario, setErrorUsuario] = useState(false);
  const [errorContrasena, setErrorContrasena] = useState(false);
  const [errorConfirmarContrasena, setErrorConfirmarContrasena] =
    useState(false);
  const [errorTelefonos, setErrorTelefonos] = useState([]);
  const [accesosForm, setAccesosForm] = useState({ accesos: [] });
  const [areaSeleccionada, setAreaSeleccionada] = useState("");

  useEffect(() => {
                if (!Array.isArray(listaCargos) || listaCargos.length === 0) {
                    ActualizarLista(CargosListar, setListaCargos);
                }
            }, [ActualizarLista, listaCargos, setListaCargos]);
    

  useEffect(() => {
    if (seleccionarDireccion) {
      setIsModalOpen(false);
      //agregarDireccion();
      console.log(formularioEmpleados.direcciones.length);
      setFormularioEmpleados((prevState) => ({
        ...prevState,
        direcciones: [...prevState.direcciones, nuevaDireccion],
      }));
      setSeleccionarDireccion(false);
      //setNuevaDireccion({ direccion: "Dirección: H5V4+2Q2, Siguatepeque, Siguatepeque, Departamento de Comayagua, Honduras", longitud: -87.84306461526864, latitud: 14.592255371946488 });
    }
  }, [seleccionarDireccion]);

  useEffect(() => {
    setErrorContrasena(!regexContrasena.test(formularioEmpleados.contrasena));
    setErrorConfirmarContrasena(
      formularioEmpleados.contrasena !== passwordConfirm
    );
    setErrorUsuario(!regexNombre.test(formularioEmpleados.nombre));
    setErrorCorreo(!regexEmail.test(formularioEmpleados.correo));
    setErrorPrimerNombre(formularioEmpleados.primerNombre.length < 3);
    setErrorPrimerApellido(formularioEmpleados.primerApellido.length < 3);

    const segundoNombre = formularioEmpleados.segundoNombre || '';
    if (segundoNombre.trim()) {
      setErrorSegundoNombre(
        !regexNombreOpcionalValido.test(segundoNombre)
      );
    } else {
      setErrorSegundoNombre(false);
    }

    const segundoApellido = formularioEmpleados.segundoApellido || '';
    if (segundoApellido.trim()) {
      setErrorSegundoApellido(
        !regexNombreOpcionalValido.test(segundoApellido)
      );
    } else {
      setErrorSegundoApellido(false);
    }

    if (formularioEmpleados.rtn) {
      setErrorRtn(!regexRTN.test(formularioEmpleados.rtn));
    } else {
      setErrorRtn(false);
    }

    if (formularioEmpleados.identidad) {
      setErrorIdentidad(!regexIdentidad.test(formularioEmpleados.identidad));
    } else {
      setErrorIdentidad(false);
    }
    const nuevosErrores = formularioEmpleados.telefonos.map((numero) =>
      !regexTelefono.test(numero.telefono)
    );
    setErrorTelefonos(nuevosErrores);
  }, [formularioEmpleados, passwordConfirm])

  useEffect(() => {
    var genero = "Masculino"; // Valor por defecto
    if (generoId === 2) genero = "Femenino";
    setFormularioEmpleados({
      ...formularioEmpleados,
      genero: genero,
    });
  }, [generoId]);

  const manejadorEmpleados = (event) => {
    setFormularioEmpleados({
      ...formularioEmpleados,
      [event.target.name]: event.target.value,
    });
  };

  const manejarCambioNumeros = (index, value) => {
    const nuevosNumeros = [...formularioEmpleados.telefonos];
    nuevosNumeros[index] = { telefono: value };

    setFormularioEmpleados({
      ...formularioEmpleados,
      telefonos: nuevosNumeros,
    });
  };

  const agregarNumero = () => {
    setFormularioEmpleados((prevState) => ({
      ...prevState,
      telefonos: [...prevState.telefonos, { telefono: "" }],
    }));
  };

  const eliminarNumero = (index) => {
    setFormularioEmpleados((prevState) => {
      const nuevosNumeros = [...prevState.telefonos];
      nuevosNumeros.splice(index, 1);
      return { ...prevState, telefonos: nuevosNumeros };
    });
  };

  const eliminarDireccion = (index) => {
    setFormularioEmpleados((prevState) => {
      const nuevasDirecciones = [...prevState.direcciones];
      nuevasDirecciones.splice(index, 1);
      return { ...prevState, direcciones: nuevasDirecciones };
    });
  };

  const BotonGuardar = () => {
    return (
      <>
        <button
          type="button"
          className="btn btn-success mr-3"
          onClick={guardarEmpleado}
        >
          Guardar
        </button>
        <button
          type="button"
          className="btn btn-warning mr-3"
          onClick={limpiarDatos}
        >
          Limpiar
        </button>
      </>
    );
  };

  const togglePermiso = (ruta, permiso) => {
    let updatedAccesos = [...accesosForm.accesos];
    let selectedIndex = updatedAccesos.findIndex(acc => acc.ruta === ruta);

    if (selectedIndex === -1) {
      updatedAccesos.push({ ruta, permisos: [permiso], estado: "Activo" });
      setAccesosForm({ accesos: updatedAccesos });
      return;
    }

    const acc = updatedAccesos[selectedIndex];
    const permisos = acc.permisos.includes(permiso)
      ? acc.permisos.filter(p => p !== permiso)
      : [...acc.permisos, permiso];

    updatedAccesos[selectedIndex] = { ...acc, permisos };

    setAccesosForm({ accesos: updatedAccesos });
  };

  const toggleRuta = (ruta) => {
    const existe = accesosForm.accesos.find(acc => acc.ruta === ruta);
    if (!existe) {
      setAccesosForm({ ...accesosForm, accesos: [...accesosForm.accesos, { ruta, permisos: [], estado: "Activo" }] });
    }
  };

  const limpiarDatos = () => {
    setFormularioEmpleados({
      id: null,
      correo: "",
      identidad: "",
      rtn: "",
      primerNombre: "",
      segundoNombre: "",
      primerApellido: "",
      segundoApellido: "",
      cargoId: null,
      telefonos: [{ telefono: "" }],
      direcciones: [{ direccion: "", longitud: null, latitud: null }],
      genero: null,
      activo: true,
      imagen: "empleados.jpeg",
      contrasena: "",
      nombre: "",
      tipoUsuario: "Empleado",
    });
    setErrorRtn(false);
    setErrorIdentidad(false);
    setErrorPrimerNombre(false);
    setErrorSegundoNombre(false);
    setErrorPrimerApellido(false);
    setErrorSegundoApellido(false);
    setErrorCorreo(false);
    setErrorUsuario(false);
    setErrorContrasena(false);
    setErrorConfirmarContrasena(false);
    setImagen(null);
    setPasswordConfirm("");
    setAccesosForm({ accesos: [] });
    setAreaSeleccionada("");
  };

  const quitarCamposVacios = (obj) => {
    return Object.keys(obj).reduce((acc, key) => {
      if (obj[key] !== "" && obj[key] !== null && obj[key] !== undefined) {
        acc[key] = obj[key];
      }
      return acc;
    }, {});
  };

  const guardarEmpleado = async () => {
    if (
      errorRtn ||
      errorIdentidad ||
      errorPrimerNombre ||
      errorSegundoNombre ||
      errorPrimerApellido ||
      errorSegundoApellido ||
      errorCorreo ||
      errorUsuario ||
      errorContrasena ||
      errorConfirmarContrasena ||
      !formularioEmpleados.cargoId ||
      accesosForm.accesos.length === 0
    ) {
      mostraAlertaError("Existen errores en los datos");
    } else {
      try {
        const direccionesVacia = formularioEmpleados.direcciones.filter(
          (f) => f.direccion !== "" || f.longitud !== null || f.latitud !== null
        );
        const telefonosVacia = formularioEmpleados.telefonos.filter(
          (f) => f.telefono !== "" || f.telefono !== null
        );
        const datos = {
          ...formularioEmpleados,
          direcciones: direccionesVacia,
          telefonos: telefonosVacia,
          accesos: accesosForm.accesos,
        };
        const nuevosDatos = quitarCamposVacios(datos);
        await AxiosPrivado.post(EmpleadosGuardar, nuevosDatos)
          .then(async (respuesta) => {
            await guardarImagen(respuesta.data.id);
            limpiarDatos();
            ActualizarLista(EmpleadosListar, setListaEmpleados);
            mostraAlertaOk("Empleado guardado correctamente");
          })
          .catch((er) => {
            const { response } = er;
            ErroresPeticion(er);
            //const msjError = response?.data?.msj || response?.data?.error?.message || "Ocurrió un error desconocido.";
            //mostraAlertaError(msjError, "error");
          });
      } catch (error) {
        console.log(error);
        mostraAlertaError("Error al guardar el empleado");
      }
    }
  };

  const guardarImagen = async (empleadoId) => {
    if (!imagen) {
      return;
    } else {
      try {
        await AxiosImagen.put(EmpleadoImagenEditar + empleadoId, imagen)
          .then((respuesta) => {
            console.log(respuesta);
            setFormularioEmpleados((prevState) => ({
              ...prevState,
              imagen: respuesta.data.imagen,
            }));
            mostraAlertaOk("Imagen actualizada correctamente");
          })
          .catch((er) => {
            const { response } = er;
            const msjError = response?.data?.msj || response?.data?.error?.message || "Ocurrió un error desconocido.";
            mostraAlertaError(msjError, "error");
          });
      } catch (error) {
        console.log(error);
        mostraAlertaError("Error al actualizar la imagen");
      }
    }
  };
  const handleFileChange = async (event) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    } else {
      try {
        let formData = new FormData();
        formData.append("imagen", event.target.files[0]);
        setImagen(formData);
        mostraAlertaOk("Imagen seleccionada correctamente");
      } catch (error) {
        console.log(error);
        mostraAlertaError("Error al actualizar la imagen");
      }
    }
  };

  const SeleccionarImagen = () => {
    console.log("Haciendo clic en SeleccionarImagen");
    if (inputRef.current) {
      inputRef.current.click();
    }
  };
  const inputRef = useRef(null);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const togglePasswordVisibilityConfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };

  return (
    <Page datos={datos}>
      <div className="row">
        <div className="col-12">
          <Card titulo="Datos del empleado" pie={<BotonGuardar />}>
            <h5>Datos generales del empleado</h5>
            <hr></hr>
            {/*Imagen*/}
            <div className="row">
              <div className="col-sm-4 col-lg-2">
                <div className="form-group">
                  <div className="text-center">
                    <img
                      className="product-image"
                      src={ImagenEmpleado + formularioEmpleados.imagen}
                      alt="Foto"
                      crossOrigin="anonymous"
                    />
                  </div>
                  <input
                    type="file"
                    style={{ display: "none" }}
                    ref={inputRef}
                    onChange={handleFileChange}
                  />
                  <button
                    type="button"
                    className="btn btn-block btn-outline-info btn-xs"
                    onClick={SeleccionarImagen}
                  >
                    Agregar
                  </button>
                </div>
              </div>

              {/**Nombre */}

              <div className="col-sm-8 col-lg-10">
                <div className="row">
                  <div className="col-sm-12 col-lg-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errorRtn ? "is-invalid" : ""
                          }`}
                        placeholder="Ingrese el rtn"
                        name="rtn"
                        value={formularioEmpleados.rtn}
                        onChange={manejadorEmpleados}
                      />
                      {errorRtn && (
                        <div className="invalid-feedback">
                          El RTN debe tener exactamente 14 dígitos.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12 col-lg-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errorIdentidad ? "is-invalid" : ""
                          }`}
                        placeholder="Ingrese la identidad"
                        name="identidad"
                        value={formularioEmpleados.identidad}
                        onChange={manejadorEmpleados}
                      />
                      {errorIdentidad && (
                        <div className="invalid-feedback">
                          La identidad debe tener exactamente 13 dígitos.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errorPrimerNombre ? "is-invalid" : ""
                          }`}
                        placeholder="Primer Nombre"
                        name="primerNombre"
                        value={formularioEmpleados.primerNombre}
                        onChange={manejadorEmpleados}
                      />
                      {errorPrimerNombre && (
                        <div className="invalid-feedback">
                          El primer nombre debe tener al menos 3 caracteres.
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errorSegundoNombre ? "is-invalid" : ""
                          }`}
                        placeholder="Segundo Nombre"
                        name="segundoNombre"
                        value={formularioEmpleados.segundoNombre}
                        onChange={manejadorEmpleados}
                      />
                      {errorSegundoNombre && (
                        <div className="invalid-feedback">
                          El segundo nombre debe tener al menos 3 caracteres.
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errorPrimerApellido ? "is-invalid" : ""
                          }`}
                        placeholder="Primer Apellido"
                        name="primerApellido"
                        value={formularioEmpleados.primerApellido}
                        onChange={manejadorEmpleados}
                      />
                      {errorPrimerApellido && (
                        <div className="invalid-feedback">
                          El primer apellido debe tener al menos 3 caracteres.
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className={`form-control ${errorSegundoApellido ? "is-invalid" : ""
                          }`}
                        id="text"
                        placeholder="Segundo Apellido"
                        name="segundoApellido"
                        value={formularioEmpleados.segundoApellido}
                        onChange={manejadorEmpleados}
                      />
                      {errorSegundoApellido && (
                        <div className="invalid-feedback">
                          El segundo apellido debe tener al menos 3 caracteres.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/**Datos del usuario */}
            <h5>Datos del usuario</h5>
            <hr></hr>
            <div className="row">
              <div className="col-sm-12 col-lg-6">
                <div className="form-group">
                  <input
                    type="text"
                    className={`form-control ${errorCorreo ? "is-invalid" : ""
                      }`}
                    placeholder="Ingrese el correo"
                    name="correo"
                    value={formularioEmpleados.correo}
                    onChange={manejadorEmpleados}
                  />
                  {errorCorreo && (
                    <div className="invalid-feedback">
                      Correo electrónico inválido
                    </div>
                  )}
                </div>
              </div>
              <div className="col-sm-12 col-lg-6">
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className={`form-control ${errorUsuario ? "is-invalid" : ""
                      }`}
                    placeholder="Nombre de usuario"
                    value={formularioEmpleados.nombre}
                    onChange={manejadorEmpleados}
                    name="nombre"
                    autocomplete="off"
                    id="usuario-empleado"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-user"></span>
                    </div>
                  </div>
                  {errorUsuario && (
                    <div className="invalid-feedback">
                      El nombre de usuario debe tener al menos 3 caracteres.
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-lg-6">
                <div className="input-group mb-3">
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Contraseña"
                    className={`form-control ${errorContrasena ? "is-invalid" : ""
                      }`}
                    value={formularioEmpleados.contrasena}
                    onChange={manejadorEmpleados}
                    name="contrasena"
                    autocomplete="new-password"
                    id="clave-nueva-empleado"
                  />

                  <div className="input-group-append">
                    <div
                      className="input-group-text"
                      onClick={togglePasswordVisibility}
                      style={{ cursor: "pointer" }}
                    >
                      <span
                        className={
                          showPassword ? "fas fa-eye-slash" : "fas fa-eye"
                        }
                      ></span>
                    </div>
                  </div>
                  {errorContrasena && (
                    <div className="invalid-feedback">
                      Contraseña inválida (debe tener mayúscula, minúscula, número, símbolo, 6-12 caracteres)
                    </div>
                  )}
                </div>
              </div>
              <div className="col-xs-12 col-lg-6">
                <div className="input-group mb-3">
                  <input
                    type={showPasswordConfirm ? "text" : "password"}
                    className={`form-control ${errorConfirmarContrasena ? "is-invalid" : ""
                      }`}
                    placeholder="Confirmar Contraseña"
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    name="passwordConfirm"
                    autocomplete="new-password"
                    id="clave-confirmar-empleado"
                  />

                  <div className="input-group-append">
                    <div
                      className="input-group-text"
                      onClick={togglePasswordVisibilityConfirm}
                      style={{ cursor: "pointer" }}
                    >
                      <span
                        className={
                          showPasswordConfirm
                            ? "fas fa-eye-slash"
                            : "fas fa-eye"
                        }
                      ></span>
                    </div>
                  </div>
                  {errorConfirmarContrasena && (
                    <div className="invalid-feedback">
                      Las contraseñas no coinciden.
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sx-12 col-md-6">
                <div className="form-group">
                  <select
                    className="form-control select2bs4"
                    style={{ width: "100%" }}
                    value={formularioEmpleados.cargoId || ""}
                    onChange={(e) =>
                      setFormularioEmpleados({
                        ...formularioEmpleados,
                        cargoId: e.target.value,
                      })
                    }
                  >
                    <option value="">Seleccione un cargo</option>
                    {cargos.map((cargo) => (
                      <option key={cargo.value} value={cargo.value}>
                        {cargo.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-sm-12 col-md-6">
                <div className="form-group">
                  <select
                    className="form-control select2bs4"
                    style={{ width: "100%" }}
                    value={generoId || ""}
                    onChange={(e) => setGeneroId(e.target.value)}
                  >
                    <option value="">Seleccione el género</option>
                    {generos.map((genero) => (
                      <option key={genero.value} value={genero.value}>
                        {genero.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            {/**Genero */}
            <h5>Estado</h5>
            <hr></hr>
            <div className="row">
              <div className="col-sm-2">
                <div className="form-group">
                  <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="customSwitch3"
                      name="activo"
                      checked={formularioEmpleados.activo}
                      onChange={(event) => {
                        setFormularioEmpleados({
                          ...formularioEmpleados,
                          activo: event.target.checked,
                        });
                      }}
                    />
                    <label
                      className="custom-control-label"
                      htmlFor="customSwitch3"
                    >
                      {formularioEmpleados.activo ? "Activo" : "Inactivo"}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            {/*Numeros de telefonos */}
            <h5>Teléfonos</h5>
            <hr></hr>
            <div className="row mb-3">
              <div className="col-sm-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={agregarNumero}
                >
                  <i className="fa fa-plus" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div className="row">
              {formularioEmpleados.telefonos.map((numero, index) => (
                <div
                  key={index}
                  className="input-group col-sm-12 col-md-6 mb-3"
                >
                  <input
                    type="text"
                    className={`form-control ${errorTelefonos[index] ? "is-invalid" : ""}`}
                    placeholder="Ej: 98908767"
                    name="telefono"
                    value={numero.telefono}
                    onChange={(event) =>
                      manejarCambioNumeros(index, event.target.value)
                    }
                  />
                  {formularioEmpleados.telefonos.length >= 1 && (
                    <button
                      type="button"
                      className="btn btn-danger mx-3"
                      onClick={() => eliminarNumero(index)}
                      width="20px"
                    >
                      <i className="fa fa-minus" aria-hidden="true"></i>
                    </button>
                  )}
                  {errorTelefonos[index] && (
                    <div className="invalid-feedback">
                      Número inválido. Debe tener entre 8 y 12 dígitos.
                    </div>
                  )}
                </div>
              ))}
            </div>
            {/*Direcciones */}
            <h5>Direcciones</h5>
            <hr></hr>
            <div className="row">
              <div className="col-12">
                <div className="pb-3">
                  <GestionUbicacion
                    direccion={nuevaDireccion}
                    setDireccion={setNuevaDireccion}
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    setSeleccionarDireccion={setSeleccionarDireccion}
                    textoBoton={"Agregar Ubicación"}
                    verdireccion={false}
                  />
                </div>
              </div>
            </div>
            {/**Direcciones */}
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  {formularioEmpleados.direcciones
                    .filter(f => f.direccion && f.latitud && f.longitud)
                    .map((f, index) => (
                      <div key={index} className="row">
                        <div className="col-9">
                          <p className="text-muted">{f.direccion}</p>
                        </div>
                        <div className="col-3">
                          <VerUbicacion direccion={f} />
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => eliminarDireccion(index)}
                          >
                            <i className="fa fa-minus" aria-hidden="true"></i>
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <h5>Configuracion de accesos</h5>
            <hr></hr>
            <p className="alert alert-info">
              NOTA: Configure los accesos mínimos requeridos antes de guardar el nuevo empleado.
              <span className="badge bg-primary text-white ms-2">{accesosForm.accesos.length} Rutas Agregadas</span>
            </p>

            {/* Accesos disponibles */}
            <div className="border rounded shadow-sm p-3 mb-4">
              <h5 className="mb-3 fw-bold">1. Seleccione un módulo para configurar</h5>
              <div className="row gx-3 gy-3">
                {Object.entries(permisosPorRuta).map(([nombre, { ruta }]) => (
                  <div key={ruta} className="col-6 col-sm-4 col-md-3 col-lg-2 my-1">
                    <button
                      type="button"
                      className={`btn w-100 text-truncate transition ${areaSeleccionada === ruta ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setAreaSeleccionada(ruta)}
                    >
                      {areaSeleccionada === ruta ? "✓ " : ""}{nombre}
                    </button>
                  </div>
                ))}
              </div>
            </div>
            {/* Configuración de permisos */}
            {areaSeleccionada && (() => {
              const entry = Object.entries(permisosPorRuta).find(([_, v]) => v.ruta === areaSeleccionada);
              if (!entry) return null;
              const [nombre, { ruta, permisos }] = entry;
              const selected = accesosForm.accesos.find(acc => acc.ruta === ruta);

              return (
                <div className="card shadow-sm mb-4 animate__animated animate__fadeIn">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="card-title mb-0 text-secondary">
                        <i className="bi bi-shield-lock-fill me-2"></i>
                        2. Permisos para: <span className="text-primary">{nombre}</span>
                      </h5>
                      <button
                        type="button"
                        className={`btn btn-sm ${selected ? 'btn-secondary disabled' : 'btn-outline-success'}`}
                        onClick={() => toggleRuta(ruta)}
                        disabled={!!selected}
                      >
                        {selected ? "Acceso Agregado" : "Agregar Acceso"}
                      </button>
                    </div>

                    {selected && (
                      <div className="row">
                        {permisos.map((perm, idx) => (
                          <div className="form-check col-md-6 col-lg-4 mb-3" key={idx}>
                            <input
                              className="form-check-input rounded shadow-sm"
                              type="checkbox"
                              checked={selected.permisos.includes(perm)}
                              onChange={() => togglePermiso(ruta, perm)}
                              id={`${ruta}-${perm}`}
                            />
                            <label className="form-check-label ms-3 fw-semibold fs-6 text-dark" htmlFor={`${ruta}-${perm}`}>
                              {perm}
                            </label>
                          </div>
                        ))}
                        <div className="col-12 mt-3">
                          <label className="form-label fw-semibold">Estado del acceso:</label>
                          <select
                            className="px-3 py-2 mx-2 rounded-md bg-gray-100 text-gray-700 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
                            value={selected.estado}
                            onChange={(e) => {
                              const updated = accesosForm.accesos.map(acc =>
                                acc.ruta === ruta ? { ...acc, estado: e.target.value } : acc
                              );
                              setAccesosForm({ ...accesosForm, accesos: updated });
                            }}
                          >
                            <option value="Activo">Activo</option>
                            <option value="Bloqueado">Bloqueado</option>
                          </select>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })()}
          </Card>
        </div>
      </div>
    </Page>
  );
};

export default NuevoEmpleado;